<div class="row">
  <div class="col-12 mb-2">
    <table
      datatable
      [dtOptions]="dtOptions"
      [dtTrigger]="dtTrigger"
      class="table table-striped mb-0"
    >
      <thead>
        <tr>
          <td style="width: 5px">Id</td>
          <th style="width: 120px">Changed On</th>
          <th style="width: 200px">Changed By</th>
          <th style="width: 120px">Source</th>
          <th style="width: 150px">Merchant Number</th>
          <th style="width: 120px">Payment Facilitator Id</th>
          <th style="width: 120px">Payment Facilitator Id Visa</th>
          <th style="width: 120px">Is Governmental</th>
          <th style="width: 120px">Customer Service PhoneNo</th>
          <th style="width: 120px">Address</th>
          <th style="width: 120px">ISO ID</th>
          <th style="width: 120px">ISO ID Visa</th>
          <th style="width: 120px">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let structuralData of auditStructualDataDetailsViewModel">
          <td style="font-size: 12px">{{ structuralData.id }}</td>
          <td style="font-size: 12px">
            {{ structuralData.changedOn | date: "MMM d, y, h:mm:ss a" }}
          </td>
          <td style="font-size: 12px">{{ structuralData.changedBy }}</td>
          <td style="font-size: 12px">{{ structuralData.source }}</td>
          <td style="font-size: 12px">{{ structuralData.merchantNumber }}</td>
          <td style="font-size: 12px">
            {{ structuralData.paymentFacilitatorId }}
          </td>
          <td style="font-size: 12px">
            {{ structuralData.paymentFacilitatorIdVisa }}
          </td>
          <td style="font-size: 12px">
            {{ structuralData.isGovernmentalMerchant }}
          </td>
          <td style="font-size: 12px">
            {{ structuralData.customerServicePhoneNo }}
          </td>
          <td style="font-size: 12px">
            {{ structuralData.merchantStreetAddress }}
          </td>
          <td style="font-size: 12px">
            {{ structuralData.independentSalesOrganizationID }}
          </td>
          <td style="font-size: 12px">
            {{ structuralData.independentSalesOrganizationIdVisa }}
          </td>
          <td style="font-size: 12px">{{ structuralData.status }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="page-title-box">
      <div class="page-title-right">
        <input
          type="button"
          value="Print"
          class="btn btn-success"
          (click)="print()"
        />
        &nbsp;
        <input
          type="button"
          value="Export to CSV"
          class="btn btn-success"
          (click)="DownloadCsv()"
        />
      </div>
    </div>
  </div>
</div>
